/* DON'T EDIT THIS FILE: edit original and run build again */ export const casfogFullLabel =
  "CAMARA ARGENTINA DE SOCIEDADES Y FONDOS DE GARANTIA";
